import React, { useEffect, useRef, useState } from 'react';
import Helmet from 'react-helmet';
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { Swiper, SwiperSlide } from 'swiper/react';
import OpenApp from '../components/OpenApp';
import ArticleList from '../components/index/ArticleList';
import SwiperStyle from '../components/style/SwiperStyle';
import { setWeixinData } from '../utils/wxShareUtil';

dayjs.locale('zh-cn');

const Index = () => {
  const [page_num, setPage_num] = useState(1);
  const [list, setList] = useState([]);
  const [hasMore, setHasMore] = useState(0);
  const [loading, setLoading] = useState(false);

  const loadingRef = useRef(false);
  const loadingDivRef = useRef(null);
  const intersectionObserver = useRef(null);

  useEffect(() => {
    if (typeof setWeixinData !== 'undefined' && page_num === 1) {
      setWeixinData();
    }
    getList();
  }, [page_num]);

  useEffect(() => {
    if (hasMore === 1) {
      intersectionObserver.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setPage_num((previous) => {
              return previous + 1
            })
          }
        },
        {
          root: null,
          rootMargin: '0px 0px 20px 0px',
          threshold: 0
        }
      );

      if (intersectionObserver.current) {
        intersectionObserver.current.observe(loadingDivRef.current);
      }
    }
    return () => {
      if (intersectionObserver.current) {
        intersectionObserver.current.unobserve(loadingDivRef.current);
        intersectionObserver.current.disconnect();
        intersectionObserver.current = null;
      }
    };
  }, [hasMore]);

  const getList = () => {
    if (loadingRef.current) {
      return;
    }
    loadingRef.current = true;
    setLoading(loadingRef.current);
    axios
      .get('/api/v1/deepnews', {
        timeout: 5000,
        params: {
          page_num,
          type: 1,
          page_size: 10
        }
      })
      .then((response) => {
        loadingRef.current = false;
        setLoading(loadingRef.current);
        if (!!response && response.status === 200) {
          if (!!response.data && response.data.code === 200) {
            const data = response.data.data;
            const deepnews_list = Array.isArray(data.deepnews_list) ? data.deepnews_list : [];
            const top_list = Array.isArray(data.top_list) ? data.top_list : [];
            const topic_list = Array.isArray(data.topic_list) ? data.topic_list : [];
            const adex_list_4 = [];
            adex_list_4.type = 'tad';
            const adex_list_8 = [];
            adex_list_8.type = 'tad';

            if (page_num === 1) {
              let tempList = top_list.concat(deepnews_list);
              if (tempList.length < 4) {
                tempList = tempList.concat(topic_list, adex_list_4, adex_list_8);
              } else if (tempList.length >= 4 && tempList.length < 7) {
                tempList.splice(3, 0, topic_list, adex_list_4);
                tempList = tempList.concat(adex_list_8);
              } else {
                tempList.splice(3, 0, topic_list, adex_list_4);
                if (!!topic_list.length && !!adex_list_4.length) {
                  tempList.splice(9, 0, adex_list_8);
                } else {
                  tempList.splice(8, 0, adex_list_8);
                }
              }

              if (
                !deepnews_list.length &&
                !top_list.length &&
                !topic_list.length &&
                !adex_list_4.length &&
                !adex_list_8.length
              ) {
                setHasMore(2);
              } else {
                setHasMore(1);
                setList(() => {
                  return tempList
                });
              }
            } else {
              setList((previous) => {
                return page_num && page_num > 1 ? previous.concat(deepnews_list) : previous
              });
              if (deepnews_list.length < 10) {
                setHasMore(2);
              }
            }
          } else {
            setHasMore(3);
          }
        } else {
          setHasMore(3);
        }
      })
      .catch((error) => {
        loadingRef.current = false;
        setLoading(loadingRef.current);
      });
  };
  return (
    <>
      <Helmet>
        <body className="bg-c-0f1214ffffff s-body" />
        <title>蓝鲸财经-财经信息服务平台</title>
        <link rel="stylesheet" href={`${process.env.REACT_APP_OSS_HOST}/css/2025071/index_2025071.css`} />
      </Helmet>
      <OpenApp openUrl="lanjing://" />
      <div>
        {Array.isArray(list) && (
          <div>
            {list.map((item, index) => {
              if (!Array.isArray(item)) {
                return <ArticleList key={item.tid} item={item} />;
              } else {
                if (!!item.length) {
                  if (item.type === 'tad') {
                    return '';
                  }

                  return (
                    <SwiperStyle className="bg-c-f8fafd topic-column-box" key={`topic-${index}`}>
                      <Swiper
                        className="o-h topic-column-banner"
                        slidesPerView="auto"
                        freeMode={true}
                        spaceBetween={12}
                      >
                        {item.map((topicItem) => {
                          return (
                            <SwiperSlide
                              className="bg-c-fff d-f f-d-c f-c-c b-r-8 topic-column-banner-item"
                              key={topicItem.id}
                            >
                              <a href={`/to/${topicItem.id}`} className="w-100p d-f f-d-c f-c-c">
                                <div className="w-47 h-47 o-h b-r-6 default-topic-column-img topic-column-banner-item-img">
                                  {!!topicItem.head_img && (
                                    <img className="w-100p h-100p o-f-c" src={topicItem.head_img} alt="" />
                                  )}
                                </div>
                                <div className="m-t-7 f-s-14 f-w-n-b c-000 t-a-c l-c-1 t-o-e o-h">{topicItem.name}</div>
                              </a>
                            </SwiperSlide>
                          );
                        })}
                      </Swiper>
                    </SwiperStyle>
                  );
                }
                return null;
              }
            })}
          </div>
        )}
        <div
          ref={loadingDivRef}
          className="t-a-c"
          onClick={() => {
            if (hasMore === 3) {
              getList();
            }
          }}
        >
          {hasMore === 3
            ? (loading ? '加载中...' : '点击重试')
            : hasMore === 1 ? (loading ? '加载中...' : '') : hasMore === 2 ? '到底了' : ''}
        </div>
      </div>
    </>
  );
};

export default Index;
